<template>
  <v-container>
    <h1>Provider Details</h1>
    <router-link
      class="default-btn text"
      :to="{ name: 'ProviderDetails', params: { providerId } }">
      See public view
    </router-link>
    <hr class="header" />

    <ProviderDetails :providerId="providerId" />
    <ProviderReviews :providerId="providerId" />
  </v-container>
</template>

<script>
import ProviderDetails from './Details'
import ProviderReviews from './ReviewsList'

export default {
  name: 'AdminProviderDetails',
  components: {
    ProviderDetails,
    ProviderReviews,
  },
  props: {
    providerId: String,
  },
}
</script>

<style lang="scss" scoped>

</style>
